import {MobileSkeletonBanner} from "@app/components/WidgetStudio/Canvas/skeletons/MobileSkeleton/Banner"
import {ShortsWorksWidget, ShortsWorksWidgetProps} from "@app/components/WidgetStudio/ShortsWorksWidget"
import {PropsWithChildren} from 'react';
import {cn} from '@shortsworks/ui/lib/utils';
import {MobileSkeletonHeader} from '@app/components/WidgetStudio/Canvas/skeletons/MobileSkeleton/Header';
import {MobileSkeletonMenu} from '@app/components/WidgetStudio/Canvas/skeletons/MobileSkeleton/Menu';
import {MobileSkeletonContents} from '@app/components/WidgetStudio/Canvas/skeletons/MobileSkeleton/Contents';

interface MobileSkeletonProps extends PropsWithChildren {
    widgetProps: ShortsWorksWidgetProps;
}

export const MobileSkeleton = ({widgetProps}: MobileSkeletonProps) => {
    const {accessKey, widgetProperties} = widgetProps;

    return (
        <div>
            <MobileSkeletonHeader />
            <MobileSkeletonMenu />
            <div className="m-5">
                <ShortsWorksWidget isMobileDevice={true} accessKey={accessKey} widgetProperties={widgetProperties} />
            </div>
            <MobileSkeletonBanner />
            <MobileSkeletonContents />
        </div>
    );
}
